import NavigationHamburger from "./NavigationHamburger";
import NavigationLogo from "./NavigationLogo";
import NavigationMenu from "./NavigationMenu";
import NavigationSocials from "./NavigationSocials";
import { Footer } from "../index.js";
import { useState } from "react";

const Navigation = () => {
  const [open, setOpen] = useState(false);
  const toggleMenu = () => setOpen((prev) => !prev);
  const closeMenu = () => setOpen(false);

  return (
    <article className="side-menu">
      {/* Jigsaw piece silhouettes for a 2-wide x 3-tall grid.
          Box 152x128, body inset 16 (16..136 x, 16..112 y), connector r=16.
          Interior joins stay complementary (knob <-> socket); outer perimeter
          edges alternate knob/socket so the whole shape has a jagged edge. */}
      <svg width="0" height="0" className="puzzle-defs" aria-hidden="true" focusable="false">
        <defs>
          {/* row0 col0 — knob top, knob right, knob bottom, socket left */}
          <clipPath id="pz1" clipPathUnits="userSpaceOnUse">
            <path d="M16 16 L60 16 A16 16 0 0 1 92 16 L136 16 L136 48 A16 16 0 0 1 136 80 L136 112 L92 112 A16 16 0 0 1 60 112 L16 112 L16 80 A16 16 0 0 0 16 48 L16 16 Z" />
          </clipPath>
          {/* row0 col1 — socket top, knob right, knob bottom, socket left */}
          <clipPath id="pz2" clipPathUnits="userSpaceOnUse">
            <path d="M16 16 L60 16 A16 16 0 0 0 92 16 L136 16 L136 48 A16 16 0 0 1 136 80 L136 112 L92 112 A16 16 0 0 1 60 112 L16 112 L16 80 A16 16 0 0 0 16 48 L16 16 Z" />
          </clipPath>
          {/* row1 col0 — socket top, knob right, knob bottom, knob left */}
          <clipPath id="pz3" clipPathUnits="userSpaceOnUse">
            <path d="M16 16 L60 16 A16 16 0 0 0 92 16 L136 16 L136 48 A16 16 0 0 1 136 80 L136 112 L92 112 A16 16 0 0 1 60 112 L16 112 L16 80 A16 16 0 0 1 16 48 L16 16 Z" />
          </clipPath>
          {/* row1 col1 — socket top, socket right, knob bottom, socket left */}
          <clipPath id="pz4" clipPathUnits="userSpaceOnUse">
            <path d="M16 16 L60 16 A16 16 0 0 0 92 16 L136 16 L136 48 A16 16 0 0 0 136 80 L136 112 L92 112 A16 16 0 0 1 60 112 L16 112 L16 80 A16 16 0 0 0 16 48 L16 16 Z" />
          </clipPath>
          {/* row2 col0 — socket top, knob right, knob bottom, socket left */}
          <clipPath id="pz5" clipPathUnits="userSpaceOnUse">
            <path d="M16 16 L60 16 A16 16 0 0 0 92 16 L136 16 L136 48 A16 16 0 0 1 136 80 L136 112 L92 112 A16 16 0 0 1 60 112 L16 112 L16 80 A16 16 0 0 0 16 48 L16 16 Z" />
          </clipPath>
          {/* row2 col1 — socket top, knob right, socket bottom, socket left */}
          <clipPath id="pz6" clipPathUnits="userSpaceOnUse">
            <path d="M16 16 L60 16 A16 16 0 0 0 92 16 L136 16 L136 48 A16 16 0 0 1 136 80 L136 112 L92 112 A16 16 0 0 0 60 112 L16 112 L16 80 A16 16 0 0 0 16 48 L16 16 Z" />
          </clipPath>
        </defs>
      </svg>
      <NavigationHamburger open={open} toggleMenu={toggleMenu} />
      <nav
        className={`main-menu${open ? " active-menu" : ""}`}
        aria-label="Primary"
      >
        <NavigationLogo closeMenu={closeMenu} />
        <NavigationMenu closeMenu={closeMenu} />
        <NavigationSocials />
        <Footer />
      </nav>
    </article>
  );
};

export default Navigation;
